// extracted by mini-css-extract-plugin
module.exports = {"books":"PageBooks_books__2H3aY","book":"PageBooks_book__morVa","book-link":"PageBooks_book-link__1dBNA","book-body":"PageBooks_book-body__3P4dF"};